import styles from './Loader.module.scss'
import loader from './assets/loader.png'

const Loader = ({ width = 40 }) =>
	(<img className={styles.loader} src={loader} alt='loader' width={width} loading="lazy" />)

export default Loader
